import { Navigate, Outlet, useLocation } from 'react-router';
import { pageRoutes } from '../../routes/page-routes';
import { useSession } from '../../shared/api/session';
import { useSessionRestored } from './session-restore';

/** Wraps every signed-in page: waits for the session check, then shows the page or the login. */
export function RequireAuth() {
  const restored = useSessionRestored();
  const { accessToken } = useSession();
  const location = useLocation();

  if (!restored) {
    return <output className="block p-8 text-center text-muted">Checking your session…</output>;
  }
  // The whole address, so a link with a query string (from Telegram, say) still opens as sent after the login
  const from = location.pathname + location.search + location.hash;
  if (!accessToken) return <Navigate to={pageRoutes.login} replace state={{ from }} />;
  return <Outlet />;
}
